import { FacebookRegularIcon as FacebookIcon, InstagramIcon, RedditIcon } from '@change/ds-icons';

import type { FullPostType } from '../SharingModal/factories/types';

/**
 * CTA button text for each post type.
 * Used by PostPreviewCard and PostPreviewCardRetry components.
 */
export const CTA_MAP: Record<FullPostType, string> = {
	facebook_post: 'Post on Facebook feed',
	facebook_group_post: 'Post on Facebook group',
	facebook_story: 'Post on Facebook story',
	instagram_post: 'Post on Instagram feed',
	instagram_story: 'Post on Instagram story',
	reddit_post: 'Post on Reddit',
	reddit_group_post: 'Post on Reddit',
};

const PLATFORM_ICONS = {
	facebook: {
		variant: 'facebook' as const,
		icon: FacebookIcon,
	},
	instagram: {
		variant: 'instagram' as const,
		icon: InstagramIcon,
	},
	reddit: {
		variant: 'reddit' as const,
		icon: RedditIcon,
	},
};

export const ICON_VARIANTS = {
	facebook_post: PLATFORM_ICONS.facebook,
	facebook_story: PLATFORM_ICONS.facebook,
	facebook_group_post: PLATFORM_ICONS.facebook,
	instagram_post: PLATFORM_ICONS.instagram,
	instagram_story: PLATFORM_ICONS.instagram,
	reddit_post: PLATFORM_ICONS.reddit,
	reddit_group_post: PLATFORM_ICONS.reddit,
};
